// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

import api from '../../axios';

export const subcategoryAPI = {
  // GET /api/budget/subcategories/
  list: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/api/budget/subcategories/${qs ? '?' + qs : ''}`);
  },

  // POST /api/budget/subcategories/
  create: (subcategory) => api.post('/api/budget/subcategories/', subcategory),

  // GET /api/budget/subcategories/<id>/
  detail: (id) => api.get(`/api/budget/subcategories/${id}/`),

  // PATCH /api/budget/subcategories/<id>/
  update: (id, data) => api.patch(`/api/budget/subcategories/${id}/`, data),

  // DELETE /api/budget/subcategories/<id>/
  delete: (id) => api.delete(`/api/budget/subcategories/${id}/`),
};

export default subcategoryAPI;
